{
	"filterError": "La matriz de campos no puede tener más de 4 elementos.",
	"perDay": "Por día",
	"byPeriod": "Por período"
}
